export default "__VITE_ASSET__BpXqEVgj__";